import React, { useEffect } from "react";
import dpone from "../assets/Aesthetic Girl Shadow Dp.jpg";
import dptwo from "../assets/✨.jpg";
import dpthree from "../assets/download (2).jpg";
import phone from "../assets/WhatsApp_Image_2024-08-12_at_11.13.25_AM-removebg-preview.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const HeaderSection = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
    AOS.init({ duration: 1000 });
    return () => {
      AOS.refresh();
    };
  }, []);



  return (
    <div>
      <div className="container-fluid">
        <div className="box_header_black bg-black rounded-5 mx-2 pb-4 pt-3">
          <div className="row text-white">
            <div className="col-md-7  ps-5">
              <div class="text-start  mt-3 mb-3 ">
                <div className="header_invesment font_weight_header ">
                  Track Your
                </div>
                <div className="flurentpink header_invesmentss fw-semibold font_size_head" data-aos="fade-right">
                  INVESTMENT
                </div>
                <div className="font_weight_header "> Today</div>
              </div>

              <div className="row  ">
                <div className="col-md-6 pt-2">
                  <div className=" button_width backg_pruple px-2 py-2 rounded-5 margin_button_header_ro_section d-flex justify-content-center" data-aos="fade-left">
                    <div className="fw-semibold text-black font_zie_getstartforfree"> Get Started For Free</div>
                  </div>
                  <div className="d-flex gap-3  " >
                    <i class="fa-solid fa-star text-warning"></i>
                    <i class="fa-solid fa-star text-warning"></i>
                    <i class="fa-solid fa-star text-warning"></i>
                    <i class="fa-solid fa-star text-warning"></i>
                    <i class="fa-solid fa-star text-warning"></i>
                    <span className="fw-semibold">5.00</span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="font_size_paragraph margin_button_header_ro_section_para">
                    Our platform provides a suite of powerful calculators
                    designed to help you make informed financial decisions with
                    ease.{" "}
                  </div>
                  <div className="font_size_paragraph ">1K+ reviews</div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-center align-items-center padding_top_3icons margin_bottom_icons image-container">
                <img src={dptwo} className="rounded_image z-0 " data-aos="zoom-in" />
                <img src={dpone} className="rounded_image z-1 second_image" data-aos="zoom-in" />
                <img src={dpthree} className="rounded_image z-2  "data-aos="zoom-in" />

                <div className="ms-3 " data-aos="fade-left">
                  <span className="fw-semibold  fs-5">+182</span>
                  <span className="flurentpink  fs-5">k</span>{" "}
                  <span className="font_size_paragraph ms-1">
                    {" "}
                    People Trust us
                  </span>
                </div>
              </div>
              <div>
                <img src={phone} className="z-3 main_img"  data-aos="fade-up" />
              </div>
            </div>
            <div className="col-md-1 d-flex flex-column justify-content-end align-items-start">
              <div className=" fw-bold font_size_paragraph text-start margin_left">
              MAKE BETTER DECISIONS
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
